import styled from 'styled-components';

export const KPISkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXS}px;

  .kpi-skeleton {
    width: fit-content;
  }
`;
